import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class CertificadosService {

  constructor(private http: HttpClient) { }

  public obtenerPlantillasCampeonato(id_campeonato){
    return this.http.get(GlobalVariable.API_SERVER_URL+"certificados/plantillas/campeonato/"+id_campeonato,GlobalVariable.httpOptions);
  }

  public guardarPlantilla(plantilla){
    return this.http.post(GlobalVariable.API_SERVER_URL+"certificados/plantillas",plantilla,GlobalVariable.httpOptions);
  }

  public actualizarPlantilla(plantilla){
    return this.http.put(GlobalVariable.API_SERVER_URL+"certificados/plantillas/"+plantilla.id,plantilla,GlobalVariable.httpOptions);
  }

  public eliminarPlantilla(plantilla){
    return this.http.delete(GlobalVariable.API_SERVER_URL+"certificados/plantillas/"+plantilla.id,GlobalVariable.httpOptions);
  }

  public obtenerFuentesEmpresa(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"certificados/fuentes/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public guardarFuente(fuente){
    return this.http.post(GlobalVariable.API_SERVER_URL+"certificados/fuentes",fuente,GlobalVariable.httpOptions);
  }

  public eliminarFuente(id_empresa,nombre){
    return this.http.delete(GlobalVariable.API_SERVER_URL+"certificados/fuentes/empresa/"+id_empresa+"/nombre/"+nombre,GlobalVariable.httpOptions);
  }

  public obtenerJugadoresCampeonato(id_campeonato){
    return this.http.get(GlobalVariable.API_SERVER_URL+"certificados/jugadores/campeonato/"+id_campeonato,GlobalVariable.httpOptions);
  }
}
